import React from "react";
import Navbar from "./Navbar";
import NavBottom from "./NavBottom";
import pic2 from "./Images/pic2.jpg"
import ProjectCards from "./ProjectCards";
import Data from "./ProjectData"
import {farpittjonline} from "./Images/ProjectImages/ttjonline.png"


const Projects = () => {
    return (
        <>
            <Navbar />
            <div className="i-main p-main">
                <h1 className="page-title">My Projects</h1>
                <section className="p-control">
                    <div className="filter-res-name">
                        <h2>Title</h2>
                    </div>
                    <div className="filter-panel">
                        <div className="filter-options">
                            <ul>
                                {/* <li><a href="#">All</a></li> */}
                                {/* <li><a href="#">E - Commerce</a></li>
                                <li><a href="#">Landing pages</a></li>
                                <li><a href="#">Small Projects</a></li> */}
                            </ul>
                        </div>
                        
                    </div>

                </section>
                <div className="p-items">
                    {Data.map(obj => {
                        return <ProjectCards image={obj.image} title={obj.title} description={obj.discription} item1={obj.used.name1} item2={obj.used.name2} item3={obj.used.name3} likes={obj.likes} link={obj.link} date={obj.data.modified} />
                    })}
                    
                    
                     
                </div>
            </div>
            <NavBottom />
        </>
    );
};

export default Projects;